import React, { Fragment, useState, useCallback, useEffect } from "react";
import { Breadcrumbs } from "../../../AbstractElements";
import { Container, Card } from "reactstrap";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { Button } from "reactstrap";
import api from "../../../api/baseApi";
import AddProducts from "./addProducts";
import { toast } from "react-toastify";
import EditProduct from "./editProduct";
import { useDispatch } from "react-redux";
const ProductsCollectionsTable = ({ name, history }) => {
  const dispatch = useDispatch();
  const collectionName = name?.toLowerCase().replace(/\s+/g, "_");

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5,
  });
  const [addPopup, setAddPopup] = useState(false);
  const [data, setData] = useState([]);
  const [totalCount, setCount] = useState(0);
  const lineClampCell = ({ cell }) => (
    <div
      style={{
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
        maxWidth: 150,
      }}
    >
      {cell.getValue()}
    </div>
  );

  const [columns, setColumns] = useState([
    {
      accessorKey: "ID",
      header: "Service ID",
      size: 150,
      Cell: lineClampCell,
    },
    {
      accessorKey: "name",
      header: "Service Name",
      size: 150,
      Cell: lineClampCell,
    },
    {
      accessorKey: "description",
      header: "Description",
      size: 150,
      Cell: lineClampCell,
    },
    {
      id: "actions",
      header: "Actions",
      size: 150,
      Cell: ({ row }) => (
        <div className="d-flex gap-2">
          <Button
            size="sm"
            color="warning"
            onClick={(e) => handleEdit(row.original)}
          >
            Edit
          </Button>
        </div>
      ),
    },
  ]);

  const handlePageChange = useCallback((event) => {
    setPagination(event);
  }, []);

  const rowAction = (event, row) => {
    console.log(event, row);
  };

  const table = useMaterialReactTable({
    columns,
    data,
    muiTableBodyRowProps: ({ row }) => ({
      // onClick: (event) => rowAction(event, row),
      onClick: () => handleEdit(row),
      sx: {
        cursor: "pointer",
      },
    }),
    manualPagination: true,
    rowCount: totalCount,
    onPaginationChange: handlePageChange,
    state: { pagination },
    initialState: { density: "compact" },
    // renderTopToolbarCustomActions: ({ table }) => (
    //   <div className="d-flex">
    //     <div
    //       sx={{
    //         display: "flex",
    //         gap: "16px",
    //         padding: "8px",
    //         flexWrap: "wrap",
    //       }}
    //     >
    //       <button
    //         className="btn bg-primary"
    //         disabled={client === "ts"}
    //         // onClick={() => setModalOpen(true)}
    //       >
    //         Create Service Grouping
    //       </button>
    //     </div>
    //   </div>
    // ),
  });

  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const getProducts = async () => {
    let { data } = await api.post("/products/getGenericProducts", { collection_slug: collectionName });
    if (data?.length && data[0]) {
      let keys = Object.keys(data[0]);
      setColumns(
        keys.map((key) => ({
          accessorKey: key,
          header: capitalizeFirstLetter(key),
          size: 150,
          Cell: lineClampCell,
        }))
      );
      let filterData = data.map((item) => {
        const newItem = {};
        Object.entries(item).forEach(([key, value]) => {
          newItem[key] =
            typeof value === "object" && value !== null
              ? JSON.stringify(value)
              : value;
        });
        return newItem;
      });

      setData(filterData);
      // console.log(keys, "product data");
    }
  };

  const [editingRow, setEditingRow] = useState(null);
  console.log(editingRow, "editingRow");
  

  const handleEdit = (rowData) => {
    setEditingRow(rowData);
  };

  useEffect(() => {
    getProducts();
  }, [pagination]);

  return (
    <Fragment>
      {editingRow ? (
        <EditProduct
          product={editingRow}
          onSuccess={() => {
            setEditingRow(null);
            getProducts();
          }}
        />
      ) : (
        <>
          {addPopup ? (
            <AddProducts collections={collectionName} history={history}
              onSuccess={() => {
                setAddPopup(false);
                getProducts();
              }}
            />
          ) : (
            <>
              <div className="mb-3 d-flex justify-content-end">
                <Button color="primary" onClick={() => setAddPopup(true)}>
                  Add Product
                </Button>
              </div>
              <Container fluid={true}>
                <Card>
                  <MaterialReactTable table={table} />
                </Card>
              </Container>
            </>
          )}
        </>
      )}
    </Fragment>
  );
};

export default ProductsCollectionsTable;
